import { WatchQueryFetchPolicy } from '@apollo/client';
import { differenceInHours, isValid } from 'date-fns';
import { IConfiguration } from 'next-common';
import { IVehicleStockEcomItem } from 'sales-types-common';
import { useClientQuery } from '../useClientQuery';
import { NEXT_ENTITY } from '@common/interfaces/entity';

interface IVehicleDataParams {
  serialNo: string;
  pCodesUpdatedAt?: string;
  configuration?: IConfiguration;
  fetchPolicy?: WatchQueryFetchPolicy;
  isUsedCar?: boolean;
}

interface IVehicleResult {
  data: IVehicleStockEcomItem;
  loading: boolean;
}

const isSkipVehicleStatusCall = (pCodesUpdatedAt: string, configuration: IConfiguration): boolean => {
  if (!pCodesUpdatedAt) return false;
  const statusApiPreventionHours = configuration?.features?.varebil?.statusApiPreventionHours ?? 0;
  try {
    const updatedDate = new Date(pCodesUpdatedAt);
    const currentDate = new Date();
    if (isValid(updatedDate)) {
      const hours = differenceInHours(currentDate, updatedDate);
      return hours < statusApiPreventionHours;
    }
    return false;
  } catch (error) {
    console.error('An error occured in differenceInHours function', error);
  }
};

export const useClientVehicleData = (params: IVehicleDataParams): IVehicleResult => {
  const isSkip = isSkipVehicleStatusCall(params?.pCodesUpdatedAt, params?.configuration);

  const { data, loading } = useClientQuery(NEXT_ENTITY.VEHICLE_DATA, {
    variables: {
      serialNo: params?.serialNo,
    },
    skip: !params?.serialNo || isSkip || params?.isUsedCar,
  });

  return { data: data, loading };
};
